import { Extension } from '@tiptap/core';

const onAttributeChange = (mutationList, observer) => {
  mutationList.forEach((mutation) => {
    if (mutation.attributeName === 'data-js-update-content') {
      const target = mutation.target;
      const value = target.attributes['data-js-update-content']?.value;

      if (value) {
        const editor = observer._editor;
        editor.chain().setContent(value).run();

        const pageContainer = editor.view.dom.closest('[data-tiptap-editor-target="page"]');
        const hiddenInput = pageContainer?.querySelector(
          'input[data-tiptap-editor-target="content"]'
        );

        if (hiddenInput) {
          hiddenInput.value = editor.getHTML();
        }

        target.attributes.removeNamedItem('data-js-update-content');
      }
    }
  });
};

const UpdateContent = Extension.create({
  name: 'updateContent',

  onCreate({ editor }) {
    editor.storage._resetRequestObserver = new MutationObserver(onAttributeChange);
    editor.storage._resetRequestObserver._editor = editor;
    editor.storage._resetRequestObserver.observe(editor.view.dom, { attributes: true });
  },
});

export default [UpdateContent];
